import React, { FunctionComponent } from 'react';
import { Text } from 'components/chroma';
import { ScreenReaderContainer } from 'components';
import { Address } from 'scenes/common/types';

export const ScreenReaderAddressInstruction: FunctionComponent<{
  items?: Address[];
}> = ({ items }) => (
  <>
    <ScreenReaderContainer>
      Start typing then select from the list below.
    </ScreenReaderContainer>
    <ScreenReaderContainer>
      {items?.length === 1
        ? `There is 1 suggestion shown.`
        : `There are ${items?.length ?? 0} suggestions shown.`}

      {items?.map((item, index) => (
        <Text role="alert" aria-live="assertive" key={item.address}>
          Option {index + 1} is {item.address}.
        </Text>
      ))}
    </ScreenReaderContainer>
  </>
);

export default ScreenReaderAddressInstruction;
